import { CELLARHOST_URL, STATIC_SERVICE_PATHS } from "@/lib/external-links";

export const serviceLinks = [
    {
        label: "Websites",
        description: "$99 one-page website offer",
        href: "/websites",
        kind: "app",
    },
    {
        label: "Askbox",
        description: "FAQ widget for an existing site",
        href: "/askbox",
        kind: "app",
    },
    {
        label: "CellarHost",
        description: "AI concierge for wineries",
        href: CELLARHOST_URL,
        kind: "external",
    },
    {
        label: "HVAC Recovery",
        description: "Missed revenue recovery for HVAC contractors",
        href: STATIC_SERVICE_PATHS.hvacRecovery,
        kind: "static",
    },
];
